import Vue from 'vue';
import App from './app';

const initAccessoriesBlock = () => {
  const vueBasketPopup = document.querySelector('#vue-accessory-list');
  if (vueBasketPopup) {
    new Vue({
      el: vueBasketPopup,
      render(h) {
        return h(App);
      },
    });
  }
};

initAccessoriesBlock();

window.initAccessoriesBlock = initAccessoriesBlock;
